"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _levelIndicator = _interopRequireDefault(require("../level-indicator/level-indicator"));

var _reactHtmlParser = _interopRequireDefault(require("react-html-parser"));

var _icon = _interopRequireDefault(require("@mapbox/mr-ui/icon"));

var _titleGenerator = require("./title-generator");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SearchResult = /*#__PURE__*/function (_React$Component) {
  _inherits(SearchResult, _React$Component);

  var _super = _createSuper(SearchResult);

  function SearchResult() {
    var _this;

    _classCallCheck(this, SearchResult);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "returnRaw", function (item) {
      if (item && item.raw && typeof item.raw !== 'string') return item.raw.join(', ');else return item && item.raw ? item.raw : '';
    });

    return _this;
  }

  _createClass(SearchResult, [{
    key: "render",
    value: function render() {
      var props = this.props;
      var getItemProps = props.downshiftProps ? props.downshiftProps.getItemProps : function () {};
      var highlighted = props.downshiftProps && props.downshiftProps.highlightedIndex === props.index;
      var site = this.returnRaw(props.result.site);
      var subsite = this.returnRaw(props.result.subsite);
      var type = this.returnRaw(props.result.contentType);
      var level = this.returnRaw(props.result.level);
      var language = this.returnRaw(props.result.codeLanguage);
      var title = this.returnRaw(props.result.title);
      var url = this.returnRaw(props.result.url);
      var excerpt = props.result.excerpt ? props.result.excerpt.snippet || props.result.excerpt.raw : '';
      var resultTitle = (0, _titleGenerator.titleGenerator)(title, subsite, site).reverse();
      return /*#__PURE__*/_react.default.createElement("div", getItemProps({
        key: props.result.id.raw,
        item: props.result,
        className: "".concat(highlighted && 'bg-gray-faint', " px12 ").concat(props.themeCompact ? 'py6 txt-s' : 'py12', " link--gray cursor-pointer")
      }), title && url && /*#__PURE__*/_react.default.createElement("div", {
        className: "block link--gray"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "mb3"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "txt-bold"
      }, resultTitle.map(function (t, index) {
        return /*#__PURE__*/_react.default.createElement("span", {
          key: "".concat(props.result.id.raw, "-").concat(t)
        }, t, resultTitle.length !== index + 1 && /*#__PURE__*/_react.default.createElement(_icon.default, {
          name: "chevron-right",
          inline: true
        }));
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "mb6"
      }, (0, _reactHtmlParser.default)(excerpt)), /*#__PURE__*/_react.default.createElement("div", {
        className: "txt-s"
      }, type ? /*#__PURE__*/_react.default.createElement("div", {
        className: "inline-block"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: ""
      }, /*#__PURE__*/_react.default.createElement(_icon.default, {
        size: 12,
        name: "book",
        inline: true
      })), /*#__PURE__*/_react.default.createElement("span", {
        className: "ml3 txt-capitalize"
      }, type)) : '', language ? /*#__PURE__*/_react.default.createElement("div", {
        className: "ml12 inline-block"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: ""
      }, /*#__PURE__*/_react.default.createElement(_icon.default, {
        size: 12,
        name: "code",
        inline: true
      })), /*#__PURE__*/_react.default.createElement("span", {
        className: "ml6"
      }, language)) : '', level ? /*#__PURE__*/_react.default.createElement("div", {
        className: "ml12 inline-block"
      }, /*#__PURE__*/_react.default.createElement(_levelIndicator.default, {
        level: parseInt(level)
      })) : '')));
    }
  }]);

  return SearchResult;
}(_react.default.Component);

SearchResult.propTypes = {
  result: _propTypes.default.object,
  index: _propTypes.default.number,
  downshiftProps: _propTypes.default.object,
  themeCompact: _propTypes.default.bool
};
var _default = SearchResult;
exports.default = _default;